<template>
  <div>
    <div class="container h-100">
      <div class="row justify-content-center align-items-center h-100">
        <div class="col-md-6 text-center">
          <div id="carouselExampleIndicators" class="carousel carousel-dark slide" data-bs-ride="carousel">
            <ol class="carousel-indicators">
              <li data-bs-target="#carouselExampleIndicators" data-bs-slide-to="0" class="active"></li>
              <li data-bs-target="#carouselExampleIndicators" data-bs-slide-to="1"></li>
              <li data-bs-target="#carouselExampleIndicators" data-bs-slide-to="2"></li>
            </ol>
            <!-- CAROUSEL ITEMS -->
            <div class="carousel-inner">
              <!-- CAROUSEL ITEM 1 -->
              <div class="carousel-item active">
                <lottie-animation
                    path="img/animations/fluid-loading-animation.json"
                    :loop="true"
                    :autoPlay="true"
                    :width="256"
                    :height="256"
                />
                <h5 class="fw-bold mt-3" v-if="user.data.displayName">
                  Hey {{ user.data.displayName || 'Username' }}!
                </h5>
                <h6 class="subtitle-1 text-muted mb-4">Hello there! We're glad you're here, there are a lot of colors
                  and tools to explore on
                  Colorffy.</h6>
                <a href="#carouselExampleIndicators" role="button" data-bs-slide="next"
                   class="btn btn-primary btn-round ripple px-5">Next</a>
              </div>
              <!-- CAROUSEL ITEM 2 -->
              <div class="carousel-item">
                <lottie-animation
                    path="img/animations/squares-loader.json"
                    :loop="true"
                    :autoPlay="true"
                    :width="256"
                    :height="256"
                />
                <h5 class="fw-bold mt-3">Let's get started</h5>
                <h6 class="subtitle-1 text-muted mb-4">You can create & save gradients or palettes, use tools like color
                  picker,
                  random colors and more!</h6>
                <a href="#carouselExampleIndicators" role="button" data-bs-slide="next"
                   class="btn btn-primary btn-round ripple px-5">Next</a>
              </div>
              <!-- CAROUSEL ITEM 3 -->
              <div class="carousel-item">
                <lottie-animation
                    path="img/animations/color-wheel.json"
                    :loop="true"
                    :autoPlay="true"
                    :width="256"
                    :height="256"
                />
                <h5 class="fw-bold mt-3">Welcome to Colorffy</h5>
                <h6 class="subtitle-1 text-muted mb-4">Colorffy it's a website for everyone who needs colors. <br>
                  Simple, Cool, Friendly</h6>
                <router-link to="/profile" class="btn btn-primary btn-round ripple px-5">Continue</router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LottieAnimation from "lottie-vuejs/src/LottieAnimation.vue";
import {mapGetters} from "vuex";

export default {
  name: 'Welcome',
  metaInfo: {
    title: 'Welcome'
  },
  components: {
    LottieAnimation
  },
  computed: {
    ...mapGetters(['user'])
  },
}
</script>